import { LoadingButton } from '@mui/lab';
import { Alert, Link, Stack, Typography } from '@mui/material';
import { LoginForm } from 'app/pages/Login';
import { useAsyncAction } from 'app/services';
import { sessionGetIp, sessionSignIn } from 'app/store/session';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link as RouterLink, Redirect } from 'react-router-dom';

const Login = () => {
  const formRef = useRef();
  const { ip, secret } = useSelector((state) => state.session);

  const { asyncAction: submit, isLoading, isError, error } = useAsyncAction(sessionSignIn);
  const { asyncAction: fetchIp } = useAsyncAction(sessionGetIp);
  const handleClickForm = () => {
    formRef.current?.handleSubmitForm();
  };

  const handleSubmitForm = (params) => {
    submit(params.email, params.password);
  };

  const handleLogKey = (e) => {
    if (e.code === 'Enter' || e.code === 'NumpadEnter') {
      e.preventDefault();
      handleClickForm();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleLogKey);

    return () => {
      document.removeEventListener('keydown', handleLogKey);
    };
  }, []);

  useEffect(() => {
    if (!ip) {
      fetchIp();
    }
  }, []);

  if (secret) {
    if (secret.qr) {
      return <Redirect to='/account/setup-2fa' />;
    }

    return <Redirect to='/account/check-2fa' />;
  }

  return (
    <React.Fragment>
      <Stack
        direction='row'
        flexDirection='column'
        sx={(theme) => ({
          paddingBottom: theme.spacing(2),
          '.MuiTypography-h5': {
            marginBottom: theme.spacing(1),
          },
          '.MuiTypography-body2': {
            color: theme.palette.text.secondary,
          },
        })}>
        <Typography variant='h5'>Авторизация</Typography>
        <Typography variant='body2'>Получите доступ к своей учетной записи, используя электронную почту и пароль.</Typography>
      </Stack>
      <LoginForm ref={formRef} onSubmit={handleSubmitForm} />
      <Stack
        direction='column'
        alignItems='center'
        justifyContent='flex-start'
        spacing={2}
        sx={(theme) => ({
          marginTop: theme.spacing(3),
          '.MuiLoadingButton-root': {
            lineHeight: '22px',
            padding: theme.spacing(2),
          },
          '.MuiAlert-root': {
            width: '100%',
            marginBottom: theme.spacing(2),
            borderRadius: theme.shape.borderRadius,
          },
        })}>
        {isError && (
          <>
            {error?.status === 418 ? (
              <Alert severity='error'>Ваша учётная запись заблокирована. Обратитесь к Администратору.</Alert>
            ) : (
              <Alert severity='error'>Не удалось войти. Пожалуйста, проверьте правильность написания логина и пароля.</Alert>
            )}
          </>
        )}
        <Stack
          direction='row'
          sx={(theme) => ({
            width: '100%',
            paddingBottom: theme.spacing(2),
            '.MuiTypography-body1': {
              '&:first-of-type': {
                color: theme.palette.text.secondary,
              },
              '&:last-of-type': {
                marginLeft: '4px',
              },
            },
          })}>
          <Typography variant='body1'>Ваш IP адрес:</Typography>
          <Typography variant='body1'>{ip ? ip : 'Не определен'}</Typography>
        </Stack>
        <LoadingButton variant='contained' loading={isLoading} onClick={handleClickForm} fullWidth disableElevation>
          Войти
        </LoadingButton>
        <Typography variant='body2'>
          <Link to='account/forgot' variant='subtitle2' underline='none' component={RouterLink}>
            Забыли пароль?
          </Link>
        </Typography>
      </Stack>
    </React.Fragment>
  );
};

export default Login;
